// extracted by mini-css-extract-plugin
module.exports = {"root":"IconGite_root__3wKrd"};